import { TextProperty } from '@components/DataDisplay/TextProperty';
import { PageSection } from '@components/PageSection/PageSection';
import { PageSectionPart } from '@components/PageSection/PageSectionPart';
import { Stack } from '@mui/material';
import { useGetProjectsQuery } from 'gql/index';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { TaskImportTasksPicker } from './TasksStep/TaskImportTasksPicker';
import { TaskImportFormValues } from './types';

export const TaskImportSummaryStep: React.FC = () => {
  const { formatMessage } = useIntl();

  const { data: projects } = useGetProjectsQuery(undefined, { select: d => d.projects });

  const taskImportForm = useFormContext<TaskImportFormValues>();

  const { projectToImportFromId: taskImportProjectId, taskIds } = useWatch({ control: taskImportForm.control });

  const project = projects?.find(p => p.id === taskImportProjectId);

  return (
    <Stack gap={2}>
      <PageSection>
        <PageSectionPart gap={2}>
          <TextProperty propertyName={formatMessage({ id: 'Project' })} propertyValue={project?.name ?? ''} />

          <TextProperty propertyName={formatMessage({ id: 'Number of folders' })} propertyValue={String(taskIds?.length ?? 0)} />
        </PageSectionPart>
      </PageSection>

      <TaskImportTasksPicker disabled />
    </Stack>
  );
};